import PropTypes from 'prop-types';
import './animated-mark.css';

const AnimatedNaraMark = ({ startup = false }) => (
  <span className={`nf-signature${startup ? ' is-startup' : ' is-looping'}`}>
    <span className="nf-signature__glow" aria-hidden="true" />
    <img
      data-testid="nara-loading-mark"
      className="nf-signature__mark nf-signature__mark--light"
      src="/nara-symbol-anim-light.svg"
      alt=""
      aria-hidden="true"
    />
    <img
      className="nf-signature__mark nf-signature__mark--dark"
      src="/nara-symbol-anim-dark.svg"
      alt=""
      aria-hidden="true"
    />
  </span>
);

AnimatedNaraMark.propTypes = { startup: PropTypes.bool };

export default AnimatedNaraMark;